import {Button} from 'primereact/button'
import {useHistory, useLocation} from 'react-router-dom'
import logo from '../../assets/icons/TaVIELogo.png'
import PageContentWrapper from '../layout/PageContentWrapper'
const PageError = () => {
    const history = useHistory()
    const location = useLocation()
    const url = location.pathname

    if (url !== '/404') {
        history.replace('/404')
        return null
    }
    return (
        <PageContentWrapper>
            <div
                className="flex align-items-center justify-content-center overflow-hidden"
                style={{minHeight: '80vh'}}>
                <div className="flex flex-column align-items-center justify-content-center">
                    <img
                        src={logo}
                        alt="Logo"
                        className="mb-3 w-6rem flex-shrink-0"
                    />
                    <div
                        style={{
                            borderRadius: '56px',
                            padding: '0.3rem',
                            background:
                                'linear-gradient(180deg, rgba(20,184,166, 0.4) 15%, rgba(20,184,166, 0) 70%)',
                        }}>
                        <div
                            className="surface-card py-8 px-5 sm:px-8 flex flex-column align-items-center"
                            style={{borderRadius: '53px'}}>
                            <div
                                className="flex justify-content-center align-items-center bg-primary border-circle mb-4"
                                style={{height: '3.2rem', width: '3.2rem'}}>
                                <i className="pi pi-fw pi-exclamation-triangle text-2xl text-white"></i>
                            </div>

                            <h1 className="text-primary text-6xl mb-2">
                                PAGE NOT FOUND
                            </h1>
                            <div className="text-color text-2xl mb-5">
                                Requested resource is not available.
                            </div>
                            <img
                                src={require('../../assets/images/404 not found.png')}
                                alt="Error"
                                className="mt-4"
                                width="30%"
                            />
                            <Button
                                icon="pi pi-arrow-left"
                                label="Go to Dashboard"
                                className="p-button-rounded"
                                onClick={() => {
                                    history.push('/')
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </PageContentWrapper>
    )
}

export default PageError
